// Application configuration
export const APP_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  REQUEST_TIMEOUT: 300000, // 5 minutes
  TOAST_AUTO_CLOSE: 1500,
  DEFAULT_PAGE_SIZE: 10,
  SUPPLIERS_PAGE_SIZE: 20,
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REQUESTS: '/requests',
  REQUEST_DETAIL: '/requests/:requestId',
  ANALYTICS: '/analytics',
  NEW_SUPPLIER: '/new-supplier',
  SUPPLIERS: '/suppliers',
  SUPPLIER_DETAIL: '/suppliers/:id',
  PO_ITEMS: '/po-items',
};
